/**
 * BoardV3 Grid Background
 * Simple CSS-based grid lines
 */

import { memo } from 'react';
import { useDayWidth, useHeaderHeight, useLayoutTotalHeight } from './BoardLayoutContext';

export const BoardV3GridBackground = memo(function BoardV3GridBackground() {
  const dayWidth = useDayWidth();
  const headerHeight = useHeaderHeight();
  const totalHeight = useLayoutTotalHeight();

  return (
    <div
      style={{
        position: 'absolute',
        top: headerHeight,
        left: 0,
        right: 0,
        height: totalHeight,
        pointerEvents: 'none',
        zIndex: 1,
        background: `repeating-linear-gradient(
          to right,
          transparent 0px,
          transparent ${dayWidth - 1}px,
          rgba(0, 0, 0, 0.05) ${dayWidth - 1}px,
          rgba(0, 0, 0, 0.05) ${dayWidth}px
        )`,
      }}
    />
  );
});
